/**
 * Default Vuetify theme for the app.
 *
 * Vuetify reads this to color every component in both light and dark
 * mode. It sets the base colors: background, surface, primary, and a
 * few editor-specific ones like the trim handle and playhead colors.
 *
 * Mental model: one object, two modes (light and dark), same color
 * keys in both so every component always finds the color it needs.
 */
import type { ThemeDefinition } from 'vuetify';

export default {
  light: {
    dark: false,
    colors: {
      background: '#F4F5F9',
      surface: '#FFFFFF',
      primary: '#8b008b',
      base: '#F4F7FA',
      scroll: '#E0E0E0',
      card: '#FFFFFF',
      dropdown: '#EFEFEF',
      outline: '#DEDFE5',
      trimaccent: '#cc6bd0',
      trimtimeline: '#7830d0',
      // Marks animation that belongs to one size (a per-size timeline copy):
      // the timeline purple, which custom rows wear striped
      timelinelocal: '#7830D0',
      playhead: '#FFCC00'
    }
  } as ThemeDefinition,
  dark: {
    dark: true,
    colors: {
      background: '#141414',
      surface: '#1A1A1A',
      primary: '#be3ac3',
      base: '#1A1A1A',
      scroll: '#444746',
      card: '#181818',
      dropdown: '#1E1E1E',
      outline: '#DEDFE5',
      trimaccent: '#c53bca',
      trimtimeline: '#7830d0',
      timelinelocal: '#A77BF3',
      playhead: '#E6B800'
    }
  } as ThemeDefinition
};
